import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { openRazorpayCheckout } from './razorpay-checkout.util';
import type {
  ConfirmSubscriptionPaymentResponse,
  InitiateSubscriptionPaymentRequest,
  RazorpayCheckoutPrefill,
} from '../models/subscription-payment.model';
import type { CpSubscriptionPaymentApiService } from '../cp-subscription-payment-api.service';

export function isSubscriptionPaymentCancelledError(err: unknown): boolean {
  let message = '';
  if (err instanceof Error) {
    message = err.message;
  } else if (typeof err === 'string') {
    message = err;
  }
  return message.toLowerCase().includes('cancelled');
}

export type ExecuteSubscriptionCheckoutInput = {
  paymentService: CpSubscriptionPaymentApiService;
  initiateRequest: InitiateSubscriptionPaymentRequest;
  merchantName: string;
  description: string;
  prefill?: RazorpayCheckoutPrefill;
  onCheckoutOpening?: () => void;
};

export function executeSubscriptionCheckout(
  input: ExecuteSubscriptionCheckoutInput,
): Observable<ConfirmSubscriptionPaymentResponse> {
  return input.paymentService.initiate(input.initiateRequest).pipe(
    switchMap((initiate) => {
      input.onCheckoutOpening?.();
      return from(
        openRazorpayCheckout({
          initiate,
          merchantName: input.merchantName,
          description: input.description,
          prefill: input.prefill,
        }),
      ).pipe(
        switchMap((checkout) =>
          input.paymentService.confirm({
            orderId: initiate.orderId,
            razorpayOrderId: checkout.razorpay_order_id,
            razorpayPaymentId: checkout.razorpay_payment_id,
            razorpaySignature: checkout.razorpay_signature,
          }),
        ),
      );
    }),
    catchError((err: unknown) => throwError(() => err)),
  );
}
